module.exports = __webpack_public_path__ + "static/media/ButtonBaseHay.84120fb8.png";